import React from "react";
import styled from "styled-components";

const Counter = ({changeCount, handleChange, counter, name}) => {

    const subtractAction = "subtract"
    const addAction = "add"

    return (
        <Container>
            <Input
                onClick={() => changeCount(name, subtractAction)}>
                -
            </Input>
            <input
                id={"input-counter"}
                type="text"
                name={name}
                value={counter}
                onChange={handleChange}
            />
            <Input
                onClick={() => changeCount(name, addAction)}>
                +
            </Input>
        </Container>
    )
}


const Container = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  width: auto;
  border: 1px rgba(166, 172, 181, 0.6) solid;
  border-left: none;
  border-right: none;

  &:focus {
    border: 10px rgba(166, 172, 181, 1) solid;
  }


  input[type=text] {
    border: none;
    background: #FAFAFA;
    text-align: center;

    &:focus {
      outline: none;
    }
`
const Input = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FAFAFA;
  background: rgba(51, 148, 246, 1);
  cursor: pointer;

  &:hover {
    background: rgba(51, 148, 246, 0.6);
  }

`


export default Counter
